module.exports = __webpack_public_path__ + "img/byr.8f4424e6.png";